@if (!isIncomplete) {
  <wc-wrapper [contentWrapper]="wrapper" [componentWidth]="showMoreDesktop ? '' : 'is-full-width'">
    <wc-base-cross-sell sd-component-wrapper-component
      [codes]="codes"
      [isEmbedded]="isEmbedded"
      [showMoreDesktop]="showMoreDesktop"
      [layout]="layout"
      [isFirst]="isFirst"
      [context]="context"
      (hasLoaded)="setLoaded()"
      [brandCorner]="brandCorner"
    />
  </wc-wrapper>
}
